var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"opacity":"0.3","clipPath":"url(#facebookicon)","key":0},React.createElement("path",{"d":"M6.25 7.21875V4.59375C6.25013 4.24569 6.38187 3.91193 6.61626 3.66582C6.85065 3.41971 7.16852 3.28139 7.5 3.28125H8.75V3.33903e-08H6.25C5.75752 -6.73103e-05 5.26986 0.101734 4.81486 0.299588C4.35986 0.497442 3.94644 0.787473 3.59821 1.15312C3.24997 1.51876 2.97375 1.95285 2.78532 2.4306C2.59689 2.90835 2.49994 3.4204 2.5 3.9375V7.21875H0V10.5H2.5V21H6.25V10.5H8.75L10 7.21875H6.25Z","fill":"#262626"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"facebookicon"},React.createElement("rect",{"width":"10","height":"21","fill":"white"})))]);
}

FacebookInline.defaultProps = {"width":"10","height":"21","viewBox":"0 0 10 21","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
